import { useState } from "react";
import { FcGoogle } from "react-icons/fc";
import { FaEye, FaEyeSlash, FaFacebook } from "react-icons/fa";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import { IoMdClose } from "react-icons/io";
import logo_back from "../../assets/admin/meteri_background_logo.svg"

const CustomerLogin = (props) => {
    const { closeModal, setShowModalLogin, setShowModalReg, restaurantId } = props;
    const { rest_name } = useParams();
    const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
    const [data, setData] = useState({ email: "", password: "" });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    const validateFields = () => {
        const newErrors = {};

        if (!data.email && !data.password) {
            const commonError = "Email and Password are required.";
            newErrors.email = commonError;
            newErrors.password = commonError;
            toast.error(commonError, {
                autoClose: 1000,
                theme: "colored",
            });
        } else {
            if (!data.email) {
                newErrors.email = "Email is required.";
                toast.error(newErrors.email, {
                    autoClose: 1000,
                    theme: "colored",
                });
            }

            if (!data.password) {
                newErrors.password = "Password is required.";
                toast.error(newErrors.password, {
                    autoClose: 1000,
                    theme: "colored",
                });
            }
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        if (!validateFields()) {
            console.log("Invalid data");
            return;
        }
        setIsLoading(true);
        const payload = {
            email: data.email,
            password: data.password,
            // userType: "Customer"
        };
        try {
            const response = await axios.post(`${apiUrl}/api/v1/restaurants/${restaurantId}/login-end-user`, payload);
            const resp = response?.data;
            if (resp.token) {
                const userType = resp?.loginUserType;
                const userId = resp?.loginUserId;
                if (userType === "customer") {
                    localStorage.setItem("token", resp?.token);
                    localStorage.setItem("currentRestId", resp?.entity?.restaurant_id);
                    localStorage.setItem("type", userType);
                    localStorage.setItem("Role", userType);
                    localStorage.setItem("RoleId", resp?.entity?.role_id);
                    localStorage.setItem("loginUserId", userId);
                    localStorage.setItem("RoleName", resp?.entity?.user_type);
                    closeModal();
                    toast.success(resp?.message, {
                        autoClose: 1500,
                        theme: "colored",
                    });
                    navigate(`/restaurant/${resp?.entity?.restaurant?.slug}`,
                        {
                            state:
                            {
                                role: userType,
                                token: resp?.token,
                                loginUser: true,
                                cusFName: resp?.entity?.firstname,
                                cusLName: resp?.entity?.lastname
                            }
                        });
                    // navigate(`/restaurant/${resp?.entity?.restaurant?.slug}`,
                    //     { state: { token: true } });
                }
            }
        } catch (err) {
            if (err?.response?.data?.message) {
                console.error(err?.response?.data?.message);
                setData({ email: "", password: "" });
                toast.error(err?.response?.data?.message, {
                    autoClose: 1000,
                    theme: "colored",
                });
            }
        } finally {
            setIsLoading(false);
        }
    };

    const handleOnChange = (e) => {
        const { name, value } = e.target;

        if ((name === "password" && (value.length > 20 || /\s/.test(value))) ||
            (name === "email" && /\s/.test(value))) {
            return;
        }
        setData((prev) => ({ ...prev, [name]: value }));
        setErrors((prev) => ({ ...prev, [name]: "" }));

    };

    // const handleOnGoogle = () => {
    //     console.log("Login with Facebook");
    //     const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
    //     const redirectUrl = `${apiUrl}/api/v1/auth/google/redirect?restaurant_id=${restaurantId}&frontend_redirect_url=http://192.168.1.161:5173/restaurant/${rest_name}`;
    //     console.log(redirectUrl, "Redirect URL for google");
    //     window.location.href = redirectUrl;
    // };

    const handleOnGoogle = () => {
        if (rest_name) {
            const { protocol, host } = window.location;
            const baseUrl = `${protocol}//${host}`;
            const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
            const frontendRedirectUrl = `${baseUrl}/restaurant/${rest_name}`;
            // console.log(frontendRedirectUrl, "frontendRedirectUrl")
            const redirectUrl = `${apiUrl}/api/v1/auth/google/redirect?restaurant_id=${restaurantId}&frontend_redirect_url=${encodeURIComponent(frontendRedirectUrl)}`;
            window.location.href = redirectUrl;
        } else {
            console.log("restaurant slug is required");
        }
    };

    // const handleOnFaceBook = () => {
    //     console.log("Login with Facebook");
    //     const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
    //     const redirectUrl = `${apiUrl}/api/v1/auth/facebook/redirect?restaurant_id=${restaurantId}&frontend_redirect_url=http://192.168.1.161:5173/restaurant/${rest_name}`;
    //     console.log(redirectUrl, "Redirect URL for Facebook");
    //     window.location.href = redirectUrl;
    // };

    const handleOnFaceBook = () => {
        if (rest_name) {
            const { protocol, host } = window.location;
            const baseUrl = `${protocol}//${host}`;
            const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
            const frontendRedirectUrl = `${baseUrl}/restaurant/${rest_name}`;
            // console.log(frontendRedirectUrl, "frontendRedirectUrl")
            const redirectUrl = `${apiUrl}/api/v1/auth/facebook/redirect?restaurant_id=${restaurantId}&frontend_redirect_url=${encodeURIComponent(frontendRedirectUrl)}`;
            window.location.href = redirectUrl;
        } else {
            console.log("restaurant slug is required");
        }
    };

    const redirectToRegister = () => {
        setShowModalLogin(false);
        setShowModalReg(true);
    }

    return (
        <>
            <div id="authentication-modal"
                role="dialog"
                aria-modal="true"
                className="fixed top-0 left-0 z-[999] flex justify-center items-center w-full h-full 
                bg-gray-900 bg-opacity-50 overflow-x-hidden overflow-y-auto md:inset-0 max-h-full">
                <div
                    className=""
                    tabIndex="-1"
                    aria-hidden="false"
                >
                    <div className="w-full max-w-sm sm:max-w-md lg:max-w-md">
                        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                            <div className="w-[90%] max-w-3xl">
                                <div className=" flex flex-col min-h-screen">
                                    <div
                                        className="flex bcklogo justify-center items-center flex-grow bg-cover bg-center"
                                        style={{
                                            backgroundImage: `url(${logo_back})`,
                                        }}
                                    >
                                        <div className="w-full max-w-sm md:max-w-[600px]">
                                            <div className="bg-[#8B2433] text-white rounded-[46px] shadow-lg px-[15px] py-[28px] sm:p-4 sm:py-4 md:py-8 md:px-6 2xl:py-12 relative">
                                                <button
                                                    className=" text-[#8B2433] text-[30px] rounded-lg absolute right-[20px] top-[20px] bg-white"
                                                    onClick={closeModal}
                                                >
                                                    <IoMdClose />
                                                </button>
                                                <h2 className="text-center text-2xl font-semibold mb-4 font-serif">Login</h2>
                                                <p className="text-center text-gray-300 text-sm mb-4 poppins-regular max-w-[208px] sm:max-w-[100%] mx-auto">
                                                    Ciao! Inserisci i tuoi dati per accedere al tuo profilo
                                                </p>
                                                <form className="mx-3 font-mono"
                                                    onSubmit={handleLogin}
                                                >
                                                    <div className="mb-4">
                                                        <input
                                                            className={`w-full px-4 py-3 text-xs rounded-3xl bg-transparent border focus:outline-none focus:border-gray-300 placeholder-[#DBDBDB] ${errors.email ? "border-red-500" : ""
                                                                }`}
                                                            type="text"
                                                            name="email"
                                                            placeholder="Email"
                                                            value={data.email}
                                                            onChange={handleOnChange}
                                                        />
                                                    </div>
                                                    <div className="mb-2 relative">
                                                        <input
                                                            className={`w-full px-4 py-3 text-xs rounded-3xl bg-transparent border focus:outline-none focus:border-gray-300 placeholder-[#DBDBDB] ${errors.password ? "border-red-500" : ""
                                                                }`}
                                                            type={showPassword ? "text" : "password"}
                                                            name="password"
                                                            placeholder="Password"
                                                            value={data.password}
                                                            onChange={handleOnChange}
                                                        />
                                                        <button
                                                            type="button"
                                                            className="absolute inset-y-0 right-4 text-gray-400 hover:text-gray-600 h-[42px]"
                                                            onClick={() => setShowPassword(!showPassword)}
                                                        >
                                                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                        </button>
                                                    </div>
                                                    <p className="text-left text-gray-300 text-sm mb-4 poppins-regular">
                                                        Problemi di accesso? <Link to={"/"}>Clicca qui</Link>
                                                    </p>
                                                    <div>
                                                        <button
                                                            className={`w-full py-2 px-4 rounded-3xl font-semibold transition duration-300 ${isLoading
                                                                ? "bg-gray-300 text-gray-500"
                                                                : "bg-white text-red-700 hover:bg-gray-100"
                                                                }`}
                                                            type="submit"
                                                            disabled={isLoading}
                                                        >
                                                            {isLoading ? (
                                                                <div className="flex justify-center items-center">
                                                                    <span className="loader mr-2 border-t-2 border-white rounded-full w-4 h-4 animate-spin"></span>
                                                                    Logging In...
                                                                </div>
                                                            ) : (
                                                                "Login"
                                                            )}
                                                        </button>
                                                    </div>
                                                </form>
                                                <p className="poppins-medium text-center text-white text-base mt-3 mb-3 poppins-regular">O</p>
                                                <div className="flex-col md:flex-row flex align-center gap-3 mx-3 ">
                                                    <button
                                                        className="text-[13px] sm:text-[15px] poppins-regular justify-center w-full flex items-center gap-4 py-2 px-4 rounded-3xl border font-semibold transition duration-300 bg-[#a14c5b] text-white"
                                                        type="submit"
                                                        onClick={handleOnGoogle}
                                                    >
                                                        <FcGoogle />
                                                        {/* Continue with Google */}
                                                        Continua con Google
                                                    </button>
                                                    <button
                                                        className="text-[13px] sm:text-[15px] poppins-regular justify-center w-full flex items-center gap-4 py-2 px-4 rounded-3xl border font-semibold transition duration-300 bg-[#a14c5b] text-white"
                                                        type="submit"
                                                        onClick={handleOnFaceBook}
                                                    >
                                                        <FaFacebook />
                                                        {/* Continue with Facebook */}
                                                        Continua con Facebook
                                                    </button>
                                                </div>
                                                <div className="text-center text-xs  mt-4 md:mt-7 poppins-regular">
                                                    <p className="text-[13px] sm:text-[15px]">
                                                        Copyright @Meteri 2024 | <a>Privacy Policy</a>
                                                    </p>
                                                </div>
                                                <div className="text-center text-xs mt-4 md:mt-6 poppins-medium">
                                                    <p>
                                                        {/* Don&apos;t have an account?{" "} */}
                                                        Non hai un account? {" "}
                                                        <span
                                                            onClick={() => redirectToRegister()}
                                                            className="cursor-pointer hover:underline"
                                                        >
                                                            Registrati
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CustomerLogin;